import Head from 'next/head';
import React from 'react';

import { subscriptionStoreSelectors } from 'modules/subscription/stores/selectors';
import { useSubscriptionStore } from 'modules/subscription/stores/subscriptionStore';

import { ALL_CONTEXTUAL_MODAL_ANIMATION_ASSET_PATHS } from './contextualModalAnimationAssetPaths';

/**
 * A component that prefetches Lottie animation assets for contextual modals,
 * but only for non-premium users who are on trial.
 *
 * This helps improve performance when these animations are needed later,
 * while avoiding unnecessary downloads for premium users who won't see upsells.
 */
export const ContextualModalAnimationPrefetch: React.FC = () => {
  // Use subscription store selectors for consistent state management
  const isOnTrialFromStore = useSubscriptionStore(subscriptionStoreSelectors.getIsOnTrial);
  const isPremiumFromStore = useSubscriptionStore(subscriptionStoreSelectors.getIsPremium);

  // Only prefetch for trial users who are not premium
  const shouldPrefetch = isOnTrialFromStore && !isPremiumFromStore;

  if (!shouldPrefetch) {
    return null;
  }

  return (
    <Head>
      {ALL_CONTEXTUAL_MODAL_ANIMATION_ASSET_PATHS.map(assetPath => (
        <link key={assetPath} rel="preload" href={assetPath} as="fetch" fetchPriority="low" crossOrigin="anonymous" type="application/json" />
      ))}
    </Head>
  );
};

export default ContextualModalAnimationPrefetch;
